import { create } from "zustand";
import { persist } from "zustand/middleware";

const useSettingstore = create(
  persist(
    (set, get) => ({
      user: {},
      settings: [], // [{ key: "jobfilter", value: {}} }, ...]

      // --- SETTINGS MANAGEMENT ---
      
      // ✅ Add or update setting by key
      addOrUpdateSetting: (newSetting) => {
        //console.log("Old Setting",get().settings)
        //console.log("New Setting",newSetting)
        set((state) => {
          const existingIndex = state.settings.findIndex(
            (s) => s.key === newSetting.key
          );

          if (existingIndex !== -1) {
            // Update existing
            const updated = [...state.settings];
            updated[existingIndex] = { ...updated[existingIndex], ...newSetting };
            return { settings: updated };
          } else {
            // Add new
            return { settings: [...state.settings, newSetting] };
          }
        });
      },

      // ✅ Get setting by key
      getSettingByKey: (key) => {
        return get().settings.find((item) => item.key === key) || null;
      },

      // ✅ Get all settings
      getSettings: () => get().settings,

      // ✅ Remove setting by key
      removeSettingByKey: (key) => {
        set((state) => ({
          settings: state.settings.filter((item) => item.key !== key),
        }));
      },

      // ✅ Clear all settings
      clearSettings: () => set({ settings: [] }),
    }),
    {
      name: "auth-store", // localStorage key
      partialize: (state) => ({ settings: state.settings }), 
      // 👆 only persist settings (not user data)
    }
  )
);

export default useSettingstore;
